@if(!loadingContent) {
  <div class="row">
    <div class="col-12">
      <div class="card">

        <div class="card-header d-flex justify-content-between align-items-center">
          <h4 class="header-title mb-0">{{ billingDetails?.company?.name }}</h4>
          <div>
            <span class="badge text-capitalize font-14 me-2" [ngClass]="getStatusBadgeClass(billingDetails?.status || '')">
              {{ getStatusText(billingDetails?.status || '') }}
            </span>
            @if(billingDetails?.gateway) {
              <span class="badge bg-info font-14 me-2">
                <i class="mdi mdi-credit-card-sync-outline me-1"></i>
                {{ billingDetails?.gateway }}
              </span>
            }
            <a (click)="generateLinkPlan($safeNavigationMigration(billingDetails?.customerId))" class="btn btn-primary btn-sm">
              <i class="mdi mdi-credit-card-outline me-1"></i>
              {{ 'shared.billingDetails.managePlan' | translate }}
            </a>
          </div>
        </div>

        <div class="card-body">

          @if (billingDetails?.checkoutInfo && !billingDetails?.subscriptionId) {
            <div class="alert alert-warning mb-4">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <h6 class="alert-heading mb-1">
                    <i class="mdi mdi-clock-outline me-2"></i>
                    {{ 'shared.billingDetails.pendingPayment' | translate }}
                  </h6>
                  <p class="mb-0">{{ 'shared.billingDetails.pendingPaymentDescription' | translate }}</p>
                </div>
                <div>
                  <a (click)="generateLinkPlan($safeNavigationMigration(billingDetails?.customerId))" class="btn btn-primary btn-sm">
                    <i class="mdi mdi-credit-card-outline me-1"></i>
                    {{ 'shared.billingDetails.managePlan' | translate }}
                  </a>
                </div>
              </div>
            </div>
          }

          <div class="table-responsive">
            <table class="table table-hover">
              <thead class="table-light">
                <tr>
                  <th>{{ 'shared.billingDetails.contractedPlan' | translate }}</th>
                  <th>{{ 'shared.billingDetails.amount' | translate }}</th>
                  <th>{{ 'shared.billingDetails.cycle' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div class="d-flex align-items-center">
                      <div class="me-3">
                        <div class="rounded-circle bg-primary bg-opacity-10 p-2">
                          <i class="mdi mdi-crown text-primary"></i>
                        </div>
                      </div>
                      <div>
                        <strong>{{ billingDetails?.currentPlan?.name }}</strong>
                        <br>
                          <small class="text-muted">ID: {{ billingDetails?.currentPlan?.id }}</small>
                        </div>
                      </div>
                    </td>
                    <td>
                      <strong class="text-success">{{ formatCurrency(billingDetails?.currentPlan?.amount || 0,
                      billingDetails?.currentPlan?.currency || 'BRL') }}</strong>
                    </td>
                    <td>
                      <span class="badge bg-light text-dark">
                        {{ getPeriodText(billingDetails?.currentPlan?.interval || 'month',
                        billingDetails?.currentPlan?.interval_count || 1) }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>

        @if (billingDetails?.currentPlan?.benefits) {
          <div>
            <div class="card">
              <div class="card-header d-flex justify-content-between align-items-center">
                <h4 class="header-title mb-0">{{ 'shared.billingDetails.planBenefits' | translate }}</h4>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-4">
                    <div class="d-flex align-items-center mb-2">
                      <i class="mdi mdi-account-group text-muted me-2"></i>
                      <span><strong>{{ totalUsers }}/{{ billingDetails?.currentPlan?.benefits?.maxUsers || 0
                      }}</strong> {{ 'shared.billingDetails.users' | translate }}</span>
                    </div>
                    <div class="progress w-100 mb-4">
                      <div class="progress-bar" role="progressbar"
                        [ngClass]="getProgressBarClass(getUsagePercentage(totalUsers, $safeNavigationMigration(billingDetails?.currentPlan?.benefits?.maxUsers)))"
                        [style.width.%]="getUsagePercentage(totalUsers, $safeNavigationMigration(billingDetails?.currentPlan?.benefits?.maxUsers))"
                        aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                      </div>
                    </div>
                    <div class="d-flex align-items-center mb-2">
                      <i class="mdi mdi-cloud-outline text-muted me-2"></i>
                      <span><strong>{{ totalCampaigns }}/{{
                      billingDetails?.currentPlan?.benefits?.maxCampaingSending || 0 }}</strong> {{ 'shared.billingDetails.campaign' | translate }}</span>
                    </div>
                    <div class="progress w-100 mb-2">
                      <div class="progress-bar" role="progressbar"
                        [ngClass]="getProgressBarClass(getUsagePercentage(totalCampaigns, $safeNavigationMigration(billingDetails?.currentPlan?.benefits?.maxCampaingSending)))"
                        [style.width.%]="getUsagePercentage(totalCampaigns, $safeNavigationMigration(billingDetails?.currentPlan?.benefits?.maxCampaingSending))"
                        aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="d-flex align-items-center mb-2">
                      <i class="mdi mdi-share-variant text-muted me-2"></i>
                      <span><strong>{{ totalChannels }}/{{ totalChannelsPlan || 0 }}</strong> {{ 'shared.billingDetails.channels' | translate }}</span>
                    </div>
                    <div class="progress w-100 mb-4">
                      <div class="progress-bar" role="progressbar"
                        [ngClass]="getProgressBarClass(getUsagePercentage(totalChannels, totalChannelsPlan))"
                        [style.width.%]="getUsagePercentage(totalChannels, totalChannelsPlan)" aria-valuenow="25"
                        aria-valuemin="0" aria-valuemax="100">
                      </div>
                    </div>
                    <div class="d-flex align-items-center mb-2">
                      <i class="mdi mdi-facebook-messenger text-muted me-2"></i>
                      <span><strong>{{ totalWebhooks }}/{{
                      billingDetails?.currentPlan?.benefits?.maxWebhookReception || 0 }}</strong> {{ 'shared.billingDetails.webhookReception' | translate }}</span>
                    </div>
                    <div class="progress w-100 mb-2">
                      <div class="progress-bar" role="progressbar"
                        [ngClass]="getProgressBarClass(getUsagePercentage(totalWebhooks, $safeNavigationMigration(billingDetails?.currentPlan?.benefits?.maxWebhookReception)))"
                        [style.width.%]="getUsagePercentage(totalWebhooks, $safeNavigationMigration(billingDetails?.currentPlan?.benefits?.maxWebhookReception))"
                        aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="d-flex align-items-center mb-2">
                      <i class="mdi mdi-contacts text-muted me-2"></i>
                      <span><strong>{{ totalContacts }}</strong> {{ 'shared.billingDetails.contacts' | translate }}</span>
                    </div>
                    <div class="progress w-100 mb-4">
                      <div class="progress-bar" role="progressbar"
                        [ngClass]="getProgressBarClass(getUsagePercentage(totalContacts, 100000))"
                        [style.width.%]="getUsagePercentage(totalContacts, 100000)" aria-valuenow="25" aria-valuemin="0"
                        aria-valuemax="100">
                      </div>
                    </div>
                    <div class="d-flex align-items-center mb-2">
                      <i class="mdi mdi-send text-muted me-2"></i>
                      <span><strong>{{ totalPublicApi }}/{{
                      (billingDetails?.currentPlan?.benefits?.maxWebhookSending || 0) }}</strong>
                    {{ 'shared.billingDetails.webhookSending' | translate }}</span>
                  </div>
                  <div class="progress w-100 mb-2">
                    <div class="progress-bar" role="progressbar"
                      [ngClass]="getProgressBarClass(getUsagePercentage(totalPublicApi, $safeNavigationMigration(billingDetails?.currentPlan?.benefits?.maxWebhookSending)))"
                      [style.width.%]="getUsagePercentage(totalPublicApi, $safeNavigationMigration(billingDetails?.currentPlan?.benefits?.maxWebhookSending))"
                      aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h4 class="header-title mb-0">{{ 'shared.billingDetails.invoiceHistory' | translate }}</h4>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead class="table-light">
                <tr>
                  <th>{{ 'shared.billingDetails.date' | translate }}</th>
                  <th>{{ 'shared.billingDetails.description' | translate }}</th>
                  <th>{{ 'shared.billingDetails.period' | translate }}</th>
                  <th>{{ 'shared.billingDetails.amount' | translate }}</th>
                  <th>{{ 'shared.billingDetails.status' | translate }}</th>
                  <th class="text-end">{{ 'shared.billingDetails.actions' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (invoice of billingDetails?.invoices || []; track invoice) {
                  <tr>
                    <td>{{ formatDate(timestampToDate($safeNavigationMigration(invoice?.created))) }}</td>
                    <td>{{ 'shared.billingDetails.invoice' | translate }} #{{ invoice.id.slice(-6).toUpperCase() }}</td>
                    <td>
                      {{ formatDate(timestampToDate($safeNavigationMigration(invoice?.period_start))) }} - {{
                      formatDate(timestampToDate($safeNavigationMigration(invoice?.period_end))) }}
                    </td>
                    <td>{{ formatCurrency($safeNavigationMigration(invoice?.amount_due), $safeNavigationMigration(invoice?.currency)) }}</td>
                    <td>
                      <span class="badge text-capitalize font-14 bg-primary" [ngClass]="getStatusBadgeClass(invoice.status)">
                        {{ getStatusText(invoice.status) }}
                      </span>
                    </td>
                    <td class="text-end">
                      @if (invoice.invoice_pdf) {
                        <a [href]="invoice.invoice_pdf" target="_blank" class="btn btn-sm btn-outline-primary">
                          <i class="mdi mdi-download"></i> {{ 'shared.billingDetails.download' | translate }}
                        </a>
                      }
                    </td>
                  </tr>
                }
                @if (!billingDetails?.invoices || billingDetails?.invoices.length === 0) {
                  <tr>
                    <td colspan="6" class="text-center py-4 text-muted">
                      {{ 'shared.billingDetails.noInvoicesFound' | translate }}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>
  </div>
} @else {
  <div class="row justify-content-center">
    <div class="col-12 col-md-8 col-lg-6 text-center my-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">{{ 'shared.billingDetails.loading' | translate }}</span>
      </div>
      <p class="mt-3">{{ 'shared.billingDetails.loadingBillingInfo' | translate }}</p>
    </div>
  </div>
}
